import { PHONE_VERIFICATION } from 'Router/routes';
import { FakePageData } from '@4finance/cwt-test-helper';

const phoneVerificationScenarios: FakePageData = {
  url: PHONE_VERIFICATION,
  items: {
    'Fill the code': [
      ['[data-test="phone-verification"]', '1234'],
      ['[data-test="phone-verification-btn-continue"]', 'submit-button'],
    ],
  },
};

export { phoneVerificationScenarios };
